import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITrack } from "@src/types/track";

interface PlaylistDetailsState {
  removeTrackFromPlaylistStatus?: "idle" | "success" | "error" | "loading";
  trackToRemove?: ITrack;
}

export const playlistDetailsInitialState: PlaylistDetailsState = {
  removeTrackFromPlaylistStatus: "idle",
  trackToRemove: undefined,
};

const playlistDetailsSlice = createSlice({
  name: "playlistDetails",
  initialState: playlistDetailsInitialState,
  reducers: {
    setRemoveTrackFromPlaylistStatus(
      state,
      action: PayloadAction<"idle" | "success" | "error" | "loading">
    ) {
      state.removeTrackFromPlaylistStatus = action.payload;
    },
    setTrackToRemove(state, action: PayloadAction<ITrack>) {
      state.trackToRemove = action.payload;
    },
    resetRemoveTrackFromPlaylist(state) {
      state.removeTrackFromPlaylistStatus =
        playlistDetailsInitialState.removeTrackFromPlaylistStatus;
      state.trackToRemove = playlistDetailsInitialState.trackToRemove;
    },
  },
});

export const {
  resetRemoveTrackFromPlaylist,
  setTrackToRemove,
  setRemoveTrackFromPlaylistStatus,
} = playlistDetailsSlice.actions;

export default playlistDetailsSlice.reducer;
